import { useNavigate as useDOMNavigate, To, NavigateOptions, NavigateFunction } from "react-router-dom";
import validator from "validator";

const goto = (url: string, replace?: boolean) => {
  if (replace) {
    window.location.replace(url);
  } else {
    window.location.href = url;
  }
};

const useNavigate = () => {
  const push = useDOMNavigate();

  const navigate = (to: To | number, options?: NavigateOptions) => {
    if (typeof to === "string" && validator.isURL(to)) goto(to, options?.replace);
    else push(to as To, options);
  };

  return navigate as NavigateFunction;
};

export { goto };
export default useNavigate;
